import React from 'react';
import { Container, Box, Typography } from '@mui/material';
import interior from '../assets/interior1.jpg';
import interior2 from '../assets/interior2.png';
const Interier = () => {
  return (
    <Container maxWidth="xl" sx={{ mt:14  , mb:3}}>
      {/* Top Intro Paragraph */}
      <Typography variant="body1" sx={{ fontSize: '1rem', mb: 4 }}>
        Vibrant PropMart offers customized services in luxurious interiors for home living spaces. The many Residential Interior Design services offered by Vibrant PropMart Interiors include Living Room Designs, Kitchen Design, Bathroom Design, Bedroom Design, Dining Room Design, Residential Indoor and Outdoor Design, Kids Room Design, Gym Design as well as Stairway Design. Our services are contemporary and traditional in nature and customized to our client’s needs.
      </Typography>

      {/* Residential Interiors Section */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          
          mb: 6,
        }}
      >
        {/* Left Text Content */}
        <Box sx={{ flex: '0 0 60%' }}>
          <Typography variant="h5" fontWeight={700} sx={{ fontSize: '20px', mb: 2 }} gutterBottom>
            Residential Interiors
          </Typography>
          <Typography variant="body1" sx={{ fontSize: '18px', mb: 2 }}>
            In residential interiors, we essentially cover everything from the living space, bath,
            kitchen, fitness center, child's room, dining area, indoor and outdoor layout to the
            stairs. You can have it in any form you like: be it the epitome of contemporary luxury
            or a replica of traditional design or a touch of both.
          </Typography>
          <Typography variant="body1" sx={{ fontSize: '18px' }}>
            Vibrant PropMart keeps updated information on modern tastes. The home interior patterns
            change from time to time, and we like to keep up with them. Our services will give your
            house a modern facelift and let your unique taste be appreciated.
          </Typography>
        </Box>

        {/* Right Image */}
        <Box sx={{ flex: '0 0 40%' }}>
          <Box
            component="img"
            src={interior}
            alt="Residential Interior"
            sx={{ width: '100%', borderRadius: 2 }}
          />
        </Box>
      </Box>

      {/* Commercial Interior Design Section */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
        
        }}
      >
        {/* Left Image */}
        <Box sx={{ flex: '0 0 40%' }}>
          <Box
            component="img"
            src={interior2}
            alt="Commercial Interior"
            sx={{ width: '95%', borderRadius: 2 }}
          />
        </Box>

        {/* Right Text Content */}
        <Box sx={{ flex: '0 0 60%' }}>
          <Typography variant="h5" fontWeight={700} sx={{ fontSize: '20px', mb: 2 }} gutterBottom>
            Commercial Interior Design
          </Typography>
          <Typography variant="body1" sx={{ fontSize: '18px', mb: 2 }}>
            Create an ideal office space, work-from-home corner, restaurant, café or salon. An
            effective interior design not only supports your business but takes it to new heights.
            Our goal is to create a forward-thinking office space that meets your business aims &
            goals.
          </Typography>
          <Typography variant="body1" sx={{ fontSize: '18px' }}>
            We take a project from an initial concept to manufacturing and installation. The idea is
            to generate maximum return on investment and to make it a truly commercial design.
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};

export default Interier;
